import { Route, Routes } from "react-router-dom";
import TagCategoriesPage from "./TagCategoriesPage";

const TagsPage = () => {
  return (
    <Routes>
      <Route index element={<TagCategoriesPage />} />
    </Routes>
  );
};

export default TagsPage;
